export default "__VITE_ASSET__CSRlBzDp__"